import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from './user-info.hooks';

export function RequireAuth({ children }: Readonly<{ children: JSX.Element }>) {
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate state={{ from: location }} to="/login" />;
  }

  return children;
}
